/* Sarasvati Designs: hide the leading "~" that we use in the Shopify admin to group seasonal/holiday collections.
   Display only: collection titles, sorting and links in Shopify are NOT changed. Remove this file to bring the "~" back. */
(function () {
  var RE = /^(\s*)~\s*/;
  function clean(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode && n.parentNode.nodeName;
        if (p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA' || p === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
        return n.nodeValue && n.nodeValue.indexOf('~') > -1 && RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var list = [], n;
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) { t.nodeValue = t.nodeValue.replace(RE, '$1'); });
    var els = root.querySelectorAll ? root.querySelectorAll('[alt*="~"],[title*="~"],[aria-label*="~"]') : [];
    Array.prototype.forEach.call(els, function (e) {
      ['alt', 'title', 'aria-label'].forEach(function (a) {
        var v = e.getAttribute(a);
        if (v && RE.test(v)) e.setAttribute(a, v.replace(RE, '$1'));
      });
    });
  }
  function run() {
    clean(document.body);
    if (document.title && RE.test(document.title)) document.title = document.title.replace(RE, '$1');
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(run, 60); })
    .observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* Sarasvati Designs: show every picture whole.
   If a picture is cropped (cover) by more than 4% inside its fixed-size box, only THAT picture switches to "whole picture, centred".
   The box (tile / banner) keeps its size, so the grid stays uniform. Wide banners get a soft blurred fill instead of empty bars. */
(function () {
  var ONLY_HOME = true;
  function isHome() { return document.body && /template-index/.test(document.body.className); }
  var THRESH = 0.04, BANNER_W = 700;
  function crop(img) {
    var b = img.getBoundingClientRect();
    if (b.width < 40 || b.height < 100 || b.width / b.height > 4.5 || !img.naturalWidth || !img.naturalHeight) return null;
    var nr = img.naturalWidth / img.naturalHeight, br = b.width / b.height;
    return { c: 1 - Math.min(br / nr, nr / br), w: b.width };
  }
  function undo(img) {
    img.removeAttribute('data-sv-whole');
    img.style.removeProperty('object-fit');
    img.style.removeProperty('object-position');
    ['position','z-index','top','bottom','left','transform','height','width','max-width','border','box-shadow','border-radius','background'].forEach(function (p) { img.style.removeProperty(p); });
    var bd = img.parentElement && img.parentElement.querySelector('img.sv-bd');
    if (bd) bd.remove();
  }
  function fit(img) {
    if (!isHome()) return;
    if (img.classList.contains('sv-bd')) return;
    var whole = img.getAttribute('data-sv-whole') === '1';
    var m = crop(img);
    if (whole) { if (!m || m.c < THRESH) undo(img); return; }
    if (!m) return;
    if (getComputedStyle(img).objectFit !== 'cover' || m.c < THRESH) return;
    img.setAttribute('data-sv-whole', '1');
    img.style.setProperty('object-fit', 'contain', 'important');
    img.style.setProperty('object-position', '50% 50%', 'important');
    if (m.w > BANNER_W && img.parentElement && !img.parentElement.querySelector('img.sv-bd')) {
      var host = img.parentElement;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var bd = document.createElement('img');
      bd.className = 'sv-bd'; bd.alt = ''; bd.setAttribute('aria-hidden', 'true');
      bd.src = img.currentSrc || img.src;
      bd.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover;filter:blur(24px) saturate(1.1);transform:scale(1.15);opacity:.6;z-index:0;pointer-events:none;max-width:none';
      host.insertBefore(bd, img);
      /* gallery-style framed print: whole picture, white mat, soft shadow, centred over the blurred backdrop */
      var S = function (k, v) { img.style.setProperty(k, v, 'important'); };
      S('position', 'absolute'); S('z-index', '1'); S('top', '24px'); S('bottom', '24px'); S('left', '50%'); S('transform', 'translateX(-50%)');
      S('height', 'calc(100% - 48px)'); S('width', 'auto'); S('max-width', 'calc(100% - 48px)'); S('object-fit', 'contain');
      S('border', '7px solid #fff'); S('border-radius', '3px'); S('box-shadow', '0 16px 44px rgba(42,58,64,.30)'); S('background', '#fff');
    }
  }
  function scan() { Array.prototype.forEach.call(document.querySelectorAll('img'), fit); }
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') fit(e.target); }, true);
  var t2; window.addEventListener('resize', function () { clearTimeout(t2); t2 = setTimeout(scan, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  setTimeout(scan, 1200); setTimeout(scan, 3500);
})();

/* Sarasvati Designs: stop the shop CDN from cutting off non-square pictures.
   The theme asks Shopify for a centre-cropped square (crop=center). For the few pictures whose real shape is not square (for example
   3:2 pillow photos), we ask for the WHOLE picture padded with white to the same square instead. Only those items change; the tile
   size stays identical, so grids stay uniform. Works for any current or future product, variant or collection picture. */
(function () {
  var cache = {};
  function pad(u) {
    var x = new URL(u, location.href);
    x.searchParams.delete('crop');
    x.searchParams.set('pad_color', 'ffffff');
    return x.href;
  }
  function padSet(s) {
    return s.split(',').map(function (part) {
      var bits = part.trim().split(/\s+/);
      if (!bits[0]) return part;
      bits[0] = pad(bits[0]);
      return bits.join(' ');
    }).join(', ');
  }
  function apply(img) {
    var ss = img.getAttribute('srcset'), s = img.getAttribute('src');
    if (ss && ss.indexOf('crop=') > -1) img.setAttribute('srcset', padSet(ss));
    if (s && s.indexOf('crop=') > -1) img.setAttribute('src', pad(s));
    img.setAttribute('data-sv-pad', '1');
  }
  function check(img) {
    if (!document.body || !/template-index/.test(document.body.className)) return;
    if (img.getAttribute('data-sv-pad') || img.__svProbe) return;
    if (img.classList.contains('sv-bd') || (img.closest && img.closest('header'))) return;
    var s = img.currentSrc || img.getAttribute('src') || '';
    if ((s.indexOf('cdn.shopify.com') < 0 && s.indexOf('/cdn/shop/') < 0) || s.indexOf('crop=') < 0) return;
    var u;
    try { u = new URL(s, location.href); } catch (e) { return; }
    var w = +u.searchParams.get('width'), h = +u.searchParams.get('height');
    if (!w || !h) return;
    img.__svProbe = 1;
    var tr = w / h, key = u.origin + u.pathname;
    function decide(pr) { if (Math.abs(pr / tr - 1) >= 0.04) apply(img); }
    if (cache[key] != null) { if (cache[key] > 0) decide(cache[key]); return; }
    var p = new URL(u.href);
    p.searchParams.delete('crop'); p.searchParams.delete('height'); p.searchParams.set('width', '48');
    var probe = new Image();
    probe.onload = function () {
      var pr = probe.naturalWidth / probe.naturalHeight;
      cache[key] = pr;
      decide(pr);
    };
    probe.onerror = function () { cache[key] = 0; };
    probe.src = p.href;
  }
  function scan() { Array.prototype.forEach.call(document.querySelectorAll('main img, #content img, footer img'), check); }
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') check(e.target); }, true);
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  setTimeout(scan, 1500);
})();

/* Sarasvati Designs: HOMEPAGE ONLY. Inside a homepage collection list, hide a LEADING season or holiday word
   (for example "Fall" in "~ Fall Mug Collection") when most cards in that list start with the same one.
   Only leading season/holiday words are ever hidden: artist names, product words and anything in the middle or end stay.
   Display only: collection names in Shopify are not changed. */
(function () {
  var SHARE = 0.75, MIN_CARDS = 4;
  var LEADS = ['back to school', 'new years eve', 'new years', 'new year', 'valentines day', 'valentines', 'mothers day', 'fathers day',
    'st patricks day', 'st patricks', 'saint patricks day', 'fourth of july', '4th of july', 'independence day', 'memorial day', 'labor day',
    'thanksgiving', 'christmas', 'halloween', 'easter', 'hanukkah', 'diwali', 'kwanzaa', 'holidays', 'holiday', 'harvest',
    'autumn', 'fall', 'winter', 'spring', 'summer'];
  function key(w) { return w.toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function toks(t) { return t.replace(/^\s*~\s*/, '').split(/\s+/).filter(Boolean); }
  function leadOf(tokens) {
    for (var n = 3; n >= 1; n--) {
      if (tokens.length < n) continue;
      var phrase = tokens.slice(0, n).map(key).join(' ');
      if (LEADS.indexOf(phrase) > -1) return { phrase: phrase, n: n };
    }
    return null;
  }
  function textNodes(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, out = [];
    while ((n = w.nextNode())) if (n.nodeValue.trim()) out.push(n);
    return out;
  }
  function shorten(section) {
    var items = [];
    Array.prototype.forEach.call(section.querySelectorAll('h5, h4, h3'), function (h) {
      if (h.getAttribute('data-sv-short')) return;
      var tn = textNodes(h);
      if (tn.length !== 1) return;
      var tokens = toks(tn[0].nodeValue.trim());
      items.push({ h: h, tn: tn[0], tokens: tokens, lead: leadOf(tokens) });
    });
    if (items.length < MIN_CARDS) return;
    var count = {};
    items.forEach(function (it) { if (it.lead) count[it.lead.phrase] = (count[it.lead.phrase] || 0) + 1; });
    items.forEach(function (it) {
      if (!it.lead || count[it.lead.phrase] / items.length < SHARE) return;
      var rest = it.tokens.slice(it.lead.n);
      while (rest.length && /^[&,:\-\u2013\u2014|]+$/.test(rest[0])) rest.shift();
      if (!rest.length) return;
      var out = rest.join(' ');
      it.tn.nodeValue = out.charAt(0).toUpperCase() + out.slice(1);
      it.h.setAttribute('data-sv-short', '1');
    });
  }
  function run() {
    if (!document.body || !/template-index/.test(document.body.className)) return;
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section[id*="collection_list"]'), shorten);
    document.documentElement.classList.add('sv-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setTimeout(run, 800); setTimeout(run, 2500);
})();

/* Sarasvati Designs: HOMEPAGE ONLY. Soft blurred copy of the banner picture behind the framed print (fades in over the CSS gradient,
   so the framed picture itself never changes after first paint). Follows whatever picture the banner uses. */
(function () {
  function add() {
    if (!document.body || !/template-index/.test(document.body.className)) return;
    var img = document.querySelector('#content picture img:not(.sv-bd)');
    if (!img || img.getBoundingClientRect().width < 300) return;
    var host = img.parentElement;
    if (!host || host.querySelector('img.sv-bd')) return;
    var src = img.currentSrc || img.getAttribute('src');
    if (!src) return;
    var bd = document.createElement('img');
    bd.className = 'sv-bd'; bd.alt = ''; bd.setAttribute('aria-hidden', 'true'); bd.src = src;
    bd.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;max-width:none;object-fit:cover;filter:blur(24px) saturate(1.1);transform:scale(1.15);opacity:.6;z-index:0;pointer-events:none';
    host.insertBefore(bd, img);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
  setTimeout(add, 600); setTimeout(add, 2000);
})();
